import { requests } from './agentDialect';

export const fetchAllMessageThread = (data) => requests.get(`/messages/thread/${data.threadId}`);

export const fetchAllUserMessages = (data) => {
    return requests.get(`/messages?user=${data.user}&tag=${data.tag}`)
};

export const markMessagesAsRead = (data) => requests.put(`/messages/read`, data);
export const deleteMessagesRequest = (data) => requests.put(`/messages/delete`, data);